import { Box, Divider, Typography } from '@mui/material';
import { CreditSubmission, UserProfile } from '@trnsact/trnsact-shared-types';

interface Props {
  selectedSubmission: CreditSubmission;
}

export const SubmissionDetails = ({ selectedSubmission }: Props) => {
  return (
    <Box display="flex" flexDirection="column">
      <Typography component="span" variant="subtitle2">
        Submission
      </Typography>
      <Typography component="span" variant="body2">
        Status: {selectedSubmission.decision}
      </Typography>
      <Typography component="span" variant="body2">
        Date of Submission: {selectedSubmission.submissionDate}
      </Typography>
      <Divider sx={{ marginTop: 0.5, marginBottom: 0.5 }} />
      <Typography component="span" variant="subtitle2">
        Lender Contact
      </Typography>
      <Typography component="span" variant="body2">
        {['fullName', 'title']
          .map(key => selectedSubmission.lenderContactInfo?.[0]?.[key as keyof UserProfile])
          .filter(Boolean)
          .join(', ')}
        {': '}
        {['email', 'phoneNumber']
          .map(key => selectedSubmission.lenderContactInfo?.[0]?.[key as keyof UserProfile])
          .filter(Boolean)
          .join(' | ')}
      </Typography>
    </Box>
  );
};
